<template>
  <van-config-provider :theme-vars="themeVars">
    <div
      class="app mainBg"
      :class="[
        route.name == 'Account' || route.name == 'Invite'
          ? 'noHeader'
          : 'hasHeader',
      ]"
    >
      <app-nav :scrollTop="scrollTop" v-if="route.name !== 'Invite'"></app-nav>

      <router-view class="router mainBg"></router-view>
    </div>
  </van-config-provider>
  <loading v-show="loadingShow"></loading>
  <van-popup v-model:show="store.linkShow">
    <empower-address></empower-address>
  </van-popup>
  <van-popup v-model:show="empowerShow" :close-on-click-overlay="false">
    <empower></empower>
  </van-popup>
  <van-popup v-model:show="accountShow">
    <account-info></account-info>
  </van-popup>
</template>

<script setup>
import empower from './components/empower.vue';
import empowerAddress from './components/empowerAddress.vue';
import appNav from './components/appNav.vue';
import loading from './components/loading.vue';
import accountInfo from './components/accountInfoAlert.vue';
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { commonStore } from '@/store/common';
import { swapStore } from '@/store/swap';
import { canvasStore } from '@/store/canvas';
const store = commonStore();
const swap_store = swapStore();
const canvas_store = canvasStore();
const loadingShow = computed(() => store.loadingShow);
const accountShow = computed(() => store.accountShow);

const empowerShow = computed(() => store.empowerShow);
const themeVars = {};
const route = useRoute();
const getInviteCode = (num) => {
  let url = num.slice(num.lastIndexOf('?') + 1); //截参数
  let arr = url.split('&');
  let obj = {};
  if (arr.length > 0) {
    arr.forEach((item, key) => {
      //循环获取参数
      const params = item.split('=')[1];
      const name = item.split('=')[0];
      obj[name] = params;
    });
  }
  //邀请码
  if (obj.code) {
    sessionStorage.setItem('parent', obj.code);
  }
};
// let transitionName = ref('slide-left');
// watch(route, (to, from) => {
//   if (to.meta.lever <= from.meta.lever) {
//     transitionName.value = 'slide-left';
//   } else {
//     transitionName.value = 'slide-right';
//   }
// });
const scrollTop = ref(0);
const scrollEvent = () => {
  scrollTop.value = window.pageYOffset;
};

onBeforeMount(() => {
  canvas_store.getColorWidth();
  window.addEventListener('scroll', scrollEvent, { passive: true });
  getInviteCode(window.location.href);
  if (store.address && store.walletType == 'wallet') {
    store.initWeb3();
    store.initMarketWeb3();
    swap_store.getTokenMethods();
  }
  if (store.address && store.walletType == 'walletConnect') {
    store.walletConnect();
    store.initMarketWeb3();
    swap_store.getTokenMethods();
  }
  if (store.address && store.walletType == 'BinanceChain') {
    store.initBSCWeb3();
    store.initMarketWeb3();
    swap_store.getTokenMethods();
  }
});
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
  min-height: calc(100vh - 55px);
  position: relative;
  transition: ease-in-out 0.2s;
}
.noHeader {
  min-height: 100vh;
}
.hasHeader {
  min-height: calc(100vh - 55px);
  margin-top: 55px;
}

@keyframes moveRight {
  0% {
    opacity: 0;
    left: 100%;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}
@keyframes moveLeft {
  0% {
    opacity: 0;
    left: -100%;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}

.slide-left {
  animation: 0.3s moveRight;
}
.slide-right {
  animation: 0.3s moveLeft;
}
</style>
